import { Box, Button as ChakraButton, Flex, Image } from '@chakra-ui/react'

import SradLogoSVG from '../../assets/data_by_SPO_logo_positive.svg'
import LogoSVG from '../../assets/logo_white_bg.svg'
import Auth from '../../helpers/auth'
import { freshchatPrepareForAuthRedirect } from '../Freshchat/freshchatClient'

const Login = () => {
  const destroyFreshchatBestEffort = async () => {
    try {
      // Keep it fast; we're about to leave the app.
      await Promise.race([
        freshchatPrepareForAuthRedirect(),
        new Promise<void>(resolve => {
          window.setTimeout(resolve, 600)
        }),
      ])
    } catch (e) {
      console.warn('Failed to prepare Freshchat for auth redirect', e)
    }
  }

  return (
    <Flex align="center" justify="center" h="100vh" direction="column" backgroundColor="#FFF">
      <Box mb="38px">
        <Image src={LogoSVG} h="150px" mb="12px" alt="Cricket Live Score Pluss Logo" />
        <Image src={SradLogoSVG} alt="Data by Sportradar Logo" />
      </Box>

      <ChakraButton
        as="a"
        href={Auth.loginUrl}
        onClick={async event => {
          event.preventDefault()
          await destroyFreshchatBestEffort()
          window.location.assign(Auth.loginUrl)
        }}
        colorScheme="cls.blue"
        size="lg"
        marginBottom="35px"
        data-testid="loginButton"
        shadow="cls.light"
      >
        Login
      </ChakraButton>
    </Flex>
  )
}

export default Login
